import $ from 'jquery';
import { ev } from '../utils';
import gsap from 'gsap';

import ScrollTriger from 'gsap/ScrollTrigger';

window.ev = ev;

export default () => {
	const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
	let currentArticle;
	const $burgerBtn = $('[data-burger] .btn-burger');

	$('body').on('click', '[data-menu="link"]', function (e) {
		const articleType = this.dataset.article;

		currentArticle = articleType;

		$burgerBtn.trigger('click', [false]);

		handleShowArticle(articleType);
	});

	$('body').on('click', '[data-article-link]', function (e) {
		const articleType = this.dataset.article;

		currentArticle = articleType;

		handleShowArticle(articleType);
	});

	document.addEventListener('showCloseButton', (e) => {
		//console.log('showCloseButton');
		$('.close-article').removeClass('-is-hidden');
	});

	document.addEventListener('hideCloseButton', (e) => {
		//console.log('hideCloseButton');
		$('.close-article').addClass('-is-hidden');
	});

	$('body').on('click', '.close-article', function (e) {
		handleHideArticle();
	});

	// $('[ data-article-show-video]')
	$('body').on('click', '[data-article-show-video]', function (e) {
		handleHideArticle();
	});

	function handleShowArticle(articleType) {
		ev('showCloseButton', {});

		loadArticle(articleType);
	}

	function handleHideArticle(articleType) {
		$('.video-segments').addClass('is-articles-last');
		ev('hideCloseButton', {});

		hideArticle(articleType);
	}

	function hideArticle() {
		const articleWrap = document.querySelector(`[data-article-${currentArticle}]`);

		ev('showVideo', { currentArticle, paused: !window.isVideoOverlayShown });
		ev('backToVideo', {
			// callback: () => {
			// 	// ev('showVideo', { currentArticle });
			// },
		});

		gsap.to(articleWrap, {
			opacity: 0,
			duration: 1,
			ease: 'power2.out',
			pointerEvents: 'none',
			onComplete: () => {
				$(articleWrap).hide();
			},
		});
	}

	function showArticle(articleType) {
		const articleWrap = document.querySelector(`[data-article-${articleType}]`);

		$(articleWrap).show();

		ev('hideVideo');

		gsap.to(articleWrap, {
			opacity: 1,
			duration: 1,
			ease: 'power2.out',
			pointerEvents: 'auto',
			onComplete: () => {
				window.dispatchEvent(new Event('resize'));
			},
		});
	}

	function loadArticle(articleType) {
		const container = document.querySelector('[data-articles]');
		const template = document.querySelector(`[data-article-template-${articleType}]`);

		if (template) {
			container.appendChild(template.content.cloneNode(true));

			template.parentNode.removeChild(template);
			setTimeout(() => {
				ev('updateScrollerProxy');
				initArticle(articleType);
				showArticle(articleType);
			}, 0);
		} else {
			console.log(articleType + ' is already loaded.');
			showArticle(articleType);
		}
	}

	function hideOtherComponents() {}

	function isTouchDeviceInit(articleWrap) {
		if (isTouchDevice) {
			document.body.classList.add('is-touch');

			articleWrap.querySelectorAll('[data-scroll]').forEach((elem) => {
				const observer = new IntersectionObserver((entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							elem.classList.add('is-inview');
						}
					});
				});

				observer.observe(elem);
			});
		}
	}

	function initArticle(articleType) {
		const articleWrap = document.querySelector(`[data-article-${articleType}]`);

		isTouchDeviceInit(articleWrap);

		//paralax img hero
		articleWrap.querySelectorAll('[data-paralax-hero-bg]').forEach((element) => {
			gsap.fromTo(
				element,
				{ y: 0 },
				{
					y: 200,
					scrollTrigger: {
						trigger: element,
						scrub: true,
						start: 'top bottom',
						end: 'bottom top',
						// markers: true,
					},
					ease: 'none',
				},
			);
		});

		//paralax img footer
		articleWrap.querySelectorAll('[data-paralax-img-footer] img').forEach((element) => {
			const elWrapper = element.closest('[data-paralax-img-footer]');
			gsap.fromTo(
				element,
				{ yPercent: -25 },
				{
					yPercent: 0,
					scrollTrigger: {
						trigger: elWrapper,
						scrub: true,
						start: 'top bottom',
						end: 'bottom bottom',
						// markers: true,
					},
					ease: 'none',
				},
			);
		});

		//paralax img bg
		articleWrap.querySelectorAll('[data-paralax-bg]').forEach((element) => {
			gsap.fromTo(
				element,
				{ y: -510 },
				{
					y: 0,
					scrollTrigger: {
						trigger: element,
						scrub: true,
						start: 'top bottom',
						end: 'bottom top',
						// markers: true,
					},
					ease: 'none',
				},
			);
		});

		if (articleWrap.querySelector('[data-anim-hero]')) {
			const heroContainer = articleWrap.querySelector('[data-anim-hero]');
			const heroBgImg = heroContainer.querySelector('.art-hero_bg img');
			const heroTitle = heroContainer.querySelector('.art-hero_tt');
			const heroOverlay = heroContainer.querySelector('.art-hero_bg_overlay');
			const heroText = heroContainer.querySelector('.art-hero_txt');

			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: heroContainer,
					start: 'top top',
					end: 'bottom top',
					scrub: true,
					// markers: true,
				},
			});

			tl.to(heroBgImg, { y: 500, ease: 'none' }, 0);

			tl.to(heroTitle, { xPercent: 0, y: 40, opacity: 0, ease: 'none' }, 0);

			tl.to(heroOverlay, { opacity: 1, ease: 'none' }, 0);

			tl.to(heroText, { opacity: 0, y: 30, ease: 'none' }, 0);
		}
	}
};
